export function setPageTitle(titleText: string): void {
  document.title = titleText + " | Fetch";
}
